import { Component, OnInit } from '@angular/core';
import { CryptoUtil } from '@qid/crypto';
import { EncryptionKeysService } from '../../services/encryption-keys.service';
import { firstValueFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { UsersSelectors } from '../../../user';
import { EncryptionKeys } from '../../model/encryption-keys.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonSegment, IonSegmentButton, IonIcon } from '@ionic/angular/standalone';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent, SuperInputComponent } from '@qid/super';

@Component({
  selector: 'set-pin',
  templateUrl: './set-pin.page.html',
  styleUrls: ['./set-pin.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    SuperInputComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSegment,
    IonSegmentButton,
    IonIcon
  ]
})
export class SetPinPage {

  public passwordInput: string;
  public setupRecoveryPin: any;
  public confirmPasswordInput: any;

  public slides = Slides;
  public activeSlide: number = 0;

  public encryptionKeys: EncryptionKeys;

  constructor(
    private encryptionKeysService: EncryptionKeysService,
    private store: Store) { }

  ionViewDidEnter() {
    this.fetchExistingEncryptionKeys()
  }

  fetchExistingEncryptionKeys = async () => {
    const authenticatedUser = await firstValueFrom(this.store.select(UsersSelectors.selectAuthenticatedUser))
    const encryptionKeys = await this.encryptionKeysService.read(authenticatedUser?._id)
    this.encryptionKeys = encryptionKeys
    encryptionKeys ? this.activeSlide = Slides.PIN_CREATED : this.activeSlide = Slides.INPUT_PIN
  }

  generateEncryptionKey = async () => {

    const authenticatedUser = await firstValueFrom(this.store.select(UsersSelectors.selectAuthenticatedUser))



  }


}
enum Slides {
  PIN_CREATED = 0,
  INPUT_PIN = 1,
  SET_RECOVERY_PIN = 2
}
